module.exports = __webpack_public_path__ + "static/media/player-info.26ce2a36.svg";